module.exports = __webpack_public_path__ + "img/MEDIA102.1b3bf867.jpg";